/**
 * Get full name of current day.
 *
 * @param lowercase {boolean}
 * @returns {string} Current day name.
 */
export default (lowercase = true) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayNumber = new Date().getDay();

    return lowercase ? days[dayNumber].toLowerCase() : days[dayNumber];
};
